// extracted by mini-css-extract-plugin
export default {"p_content":"b18af02601"};